import React, { useEffect } from 'react'
import HeroSection from './HeroSection'
import BenefitsSection from './BenefitsSection'
import TeamSection from './TeamSection'

const ContactUs = () => {


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  return (
    <div>
      <HeroSection />
      <BenefitsSection />
      <TeamSection />
    </div>
  );
};

export default ContactUs;